module.exports = __webpack_public_path__ + "staticcomp/img/content_2.90ba68a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/3/3/content_2.jpg
// module id = S6qm
// module chunks = 39